import React from 'react'

export const RefreshIcon = () => {
  return (
      <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 10.0986C21 10.0986 18.995 7.36685 17.3662 5.73688C15.7373 4.1069 13.4864 3.09863 11 3.09863C6.02944 3.09863 2 7.12807 2 12.0986C2 17.0692 6.02944 21.0986 11 21.0986C15.1031 21.0986 18.5649 18.3529 19.6482 14.5986M21 10.0986V4.09863M21 10.0986H15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

  )
}